<template>
    <searchContainer :searchHandler="search" :resetHandler="reset">
        <template v-slot:items>
            <div class="row">
                <input-number v-model="filters.captain_id" :options="{ id: 'captain_id', step: 1, label: 'captain_id' }"/>
                <select-transaction-types v-model="filters.transaction_type" :options="{ id: 'transaction_type', transPrefix: `${transPrefix}.fields`, label: 'transaction_type', placeholder: 'placeholders.all' }"/>
                <select-withdraw-status v-model="filters.withdraw_status" :options="{ id: 'withdraw_status', label: 'status', placeholder: 'placeholders.all', multiple: true }"/>
            </div>
            <div class="row">
                <input-date v-model="filters.created_from" :options="{ id: 'created_from', label: 'created_from' }"/>
                <input-date v-model="filters.created_to" :options="{ id: 'created_to', label: 'created_to' }"/>
                <input-date v-model="filters.updated_from" :options="{ id: 'updated_from', label: 'updated_from' }"/>
                <input-date v-model="filters.updated_to" :options="{ id: 'updated_to', label: 'updated_to' }"/>
            </div>
        </template>
    </searchContainer>
</template>
<script>

    import {mapGetters} from "vuex";
    import {CRUD_SEARCH_RESET} from "actions/crud";
    import searchContainer from "@/components/crud/card/CardSearch";

    const CRUD_CODE = "withdraw_requests";
    export default {
        name: "WithdrawRequestSearch",
        components: {
            searchContainer
        },
        props: {
            listHandler: {
                type: Function,
                default: () => {
                }
            },
        },
        data() {
            return {
                transPrefix: CRUD_CODE,
                filters: {
                    captain_id: this.getFilterByKey('captain_id'),
                    transaction_type: this.getFilterByKey('transaction_type'),
                    withdraw_status: this.getFilterByKey('withdraw_status'),
                    updated_from: this.getFilterByKey('updated_from'),
                    updated_to: this.getFilterByKey('updated_to'),
                    created_from: this.getFilterByKey('created_from'),
                    created_to: this.getFilterByKey('created_to'),
                },
                filtersMap: {
                    captain_id: 'captainId',
                    transaction_type: 'transactionType',
                    withdraw_status: 'withdrawStatuses',
                    updated_from: 'updatedFromDate',
                    updated_to: 'updatedToDate',
                    created_from: 'startDate',
                    created_to: 'endDate',
                }
            }
        },
        mounted() {
            this.setSearchParams(this.filters, this.filtersMap);
        },
        computed: {
            ...mapGetters([
                "getSearchFilters"
            ])
        },
        methods: {
            search() {
                this.resetPagination();
                this.setSearchParams(this.filters, this.filtersMap, {routeParams: this.getFilters(this.filters)});
                this.pushRoute(this.getSearchFilters);
                this.listHandler();
            },
            reset() {
                this.resetPagination();
                this.$store.dispatch(CRUD_SEARCH_RESET);
                this.filters = this.clearFilters(this.filters);
                this.pushRoute();
                this.listHandler();
            },
            resetPagination() {
                //Reset Pagination
                this.$emit('input', 0);
            },
            pushRoute(query = {}) {
                this.$router.push({name: this.$route.name, query}).catch(() => {});
            },
        }
    };
</script>
